import { Routes } from '@angular/router';

// Layouts
import { CommonLayoutComponent } from './common/common-layout.component';
import { HomeComponent } from './home/home.component';
import { KeyGuard } from './guards/key.guard';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'audience/dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: CommonLayoutComponent,
    children: [
      {
        path: 'fauxbox/:routingNum',
        loadChildren: './fauxbox/fauxbox.modules#FauxboxModules',
      },
      {
        path: 'creatives/:routingNum',
        canActivate: [KeyGuard],
        loadChildren: './creatives/creatives.module#CreativesModule',
      },
      {
        path: 'trends-insights/:routingNum',
        canActivate: [KeyGuard],
        loadChildren:
          './trends-insights/trends-insights.module#TrendsInsightsModule',
      },
      {
        path: 'home/:routingNum',
        canActivate: [KeyGuard],
        component: HomeComponent,
        data: {
          title: 'Home',
          breadcrumb: [
            {
              label: 'Home',
              url: '/home',
            },
            {
              label: 'Home',
              url: '',
            },
          ],
        },
      },
    ],
  },
];
